var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseAtom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 233,
    viewBox: "0 0 338 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7108 183.983C48.7838 183.649 48.2313 182.42 48.4767 181.06C48.7629 179.732 49.9872 179.143 50.9142 179.477L81.7249 188.911C83.053 189.197 83.642 190.422 83.3082 191.349C83.0221 192.677 81.7978 193.266 80.4332 192.984L49.7108 183.983ZM235.947 137.449C236.874 137.783 237.864 138.96 237.531 139.887C237.245 141.215 236.072 142.242 235.145 141.908L187.859 133.54C186.932 133.206 185.942 132.03 186.224 130.665C186.557 129.738 187.734 128.748 188.661 129.082L235.947 137.449ZM138.344 110.129C139.323 110.9 139.876 112.129 139.141 113.103C138.421 114.52 137.145 114.671 136.166 113.9L102.815 94.2658C101.836 93.4945 101.283 92.2658 102.018 91.2912C102.789 90.3123 104.018 89.7598 104.992 90.4947L138.344 110.129Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 76.6179C197.186 75.639 198.462 75.4876 199.441 76.2589C200.42 77.0302 200.571 78.3063 199.8 79.2852L179.781 105.657C179.01 106.636 177.734 106.787 176.755 106.016C175.776 105.245 175.625 103.969 176.396 102.99L196.415 76.6179Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.666 147.509C144.437 146.53 145.713 146.378 146.692 147.15C147.671 147.921 147.874 149.635 147.099 150.577L120.6 181.231C119.828 182.21 118.5 181.923 117.521 181.152C116.542 180.381 116.829 179.053 117.6 178.074L143.666 147.509Z",
    fill: "#263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271.82,
    cy: 147.086,
    r: 36.5,
    transform: "rotate(-6.76504 271.82 147.086)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7967,
    cy: 81.424,
    r: 21.5,
    transform: "rotate(-6.76504 86.7967 81.424)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.44,
    cy: 196.263,
    r: 21.5,
    transform: "rotate(-6.76504 103.44 196.263)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.115,
    cy: 126.365,
    r: 29,
    transform: "rotate(-6.76504 162.115 126.365)",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.065,
    cy: 68.0458,
    r: 14.5,
    transform: "rotate(-6.76504 208.065 68.0458)",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.143,
    cy: 176.435,
    r: 16,
    transform: "rotate(-6.76504 37.143 176.435)",
    fill: "#80FFAF",
    stroke: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseAtom2);
export default __webpack_public_path__ + "static/media/case-atom-2.a280e8179a61f547f8190c0a8d1e8f35.svg";
export { ForwardRef as ReactComponent };